import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { cn } from "@/lib/utils";

interface VideoTimelineProps {
  currentTime: number;
  duration: number;
  onSeek: (value: number[]) => void;
  onSeekCommit?: () => void;
  isFullscreen?: boolean;
  disabled?: boolean;
  onPointerDown?: (e: React.PointerEvent) => void;
  className?: string;
  children?: React.ReactNode;
}

export function VideoTimeline({
  currentTime,
  duration,
  onSeek,
  onSeekCommit,
  isFullscreen,
  disabled,
  onPointerDown,
  className,
  children,
}: VideoTimelineProps) {
  return (
    <div
      className={cn("group relative w-full", className)}
      style={{ touchAction: "none", cursor: "pointer" }}
      onPointerDown={onPointerDown}
    >
      {children}
      <SliderPrimitive.Root
        value={[currentTime]}
        max={duration || 100}
        min={0}
        step={0.1}
        disabled={disabled}
        onValueChange={onSeek}
        onValueCommit={onSeekCommit}
        className={cn(
          "relative flex w-full touch-none select-none items-center",
          isFullscreen ? "py-3" : "py-2"
        )}
        data-testid="slider-seek"
      >
        <SliderPrimitive.Track
          className={cn(
            "relative w-full grow overflow-hidden rounded-full transition-all duration-150",
            "h-1 group-hover:h-[6px]",
            isFullscreen ? "bg-white/30" : "bg-secondary"
          )}
        >
          <SliderPrimitive.Range className="absolute h-full bg-primary" />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb
          className={cn(
            "block rounded-full border-2 border-primary bg-background",
            "ring-offset-background focus-visible:outline-none focus-visible:ring-2",
            "focus-visible:ring-ring focus-visible:ring-offset-2",
            "disabled:pointer-events-none disabled:opacity-50",
            isFullscreen ? "h-5 w-5" : "h-3 w-3"
          )}
        />
      </SliderPrimitive.Root>
    </div>
  );
}
